export const cleanVersionStringWithFix = (versionWithFix) => {
  const [year, month, day, fix] = versionWithFix.split('.');
  return { version: `${year}.${month}.${day}`, fix };
};
